import { render, staticRenderFns } from "./scoringSetList.vue?vue&type=template&id=c34502b4&scoped=true&"
import script from "./scoringSetList.vue?vue&type=script&lang=js&"
export * from "./scoringSetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34502b4",
  null
  
)

export default component.exports